import type { PositionType, ProtocolId } from '@infinex/asset-config';

import { groupBalancesByGroupId } from './groupBalancesByGroupId';

import type { AccountAddress } from '../../../types';
import type {
  ChainPositionChainAssetBalance,
  PositionBalancesByGroupIdByTypeByProtocolId,
} from '../balance';

export const groupPositionsByProtocolIdByGroupId = (
  balances: ChainPositionChainAssetBalance[],
  accountAddresses: AccountAddress[]
): PositionBalancesByGroupIdByTypeByProtocolId => {
  const balancesByProtocolIdByGroupId: Partial<
    Record<
      ProtocolId,
      Partial<Record<PositionType, ChainPositionChainAssetBalance[]>>
    >
  > = {};

  for (const balance of balances) {
    if (!balancesByProtocolIdByGroupId[balance.positionData.protocolId]) {
      balancesByProtocolIdByGroupId[balance.positionData.protocolId] = {};
    }

    if (
      !balancesByProtocolIdByGroupId[balance.positionData.protocolId]![
        balance.positionData.positionType
      ]
    ) {
      balancesByProtocolIdByGroupId[balance.positionData.protocolId]![
        balance.positionData.positionType
      ] = [];
    }

    balancesByProtocolIdByGroupId[balance.positionData.protocolId]![
      balance.positionData.positionType
    ]!.push(balance);
  }

  const positionBalancesByGroupIdByTypeByProtocolId: PositionBalancesByGroupIdByTypeByProtocolId =
    {};
  for (const [protocolId, balancesByType] of Object.entries(
    balancesByProtocolIdByGroupId
  )) {
    positionBalancesByGroupIdByTypeByProtocolId[protocolId as ProtocolId] = {};
    for (const [positionType, balances] of Object.entries(balancesByType)) {
      positionBalancesByGroupIdByTypeByProtocolId[protocolId as ProtocolId]![
        positionType as PositionType
      ] = groupBalancesByGroupId(balances, accountAddresses);
    }
  }

  return positionBalancesByGroupIdByTypeByProtocolId;
};
